import classNames from 'classnames'
import { Switch } from '../switch.tsx'
import * as styles from './ci-run-setting.css.ts'

const CI_RUN_SETTING_LABEL = 'Create scans when a CI run completes'

const CiRunSetupSteps: React.FC = () => (
  <ol className={styles.setupSteps} aria-label="Azure DevOps setup">
    <li>In Organization → Integrations, copy the webhook URL from the Azure DevOps connection&apos;s Manage drawer.</li>
    <li>
      In the Azure DevOps project, add a &quot;Build completed&quot; service hook that posts to that URL. Optionally
      filter it to the pipeline that runs Polaris.
    </li>
    <li>Keep the Black Duck Security Scan step waiting for scan results, which is its default.</li>
    <li>
      For SCA, run <code>pixee sbom upload</code> earlier in the same pipeline.
    </li>
  </ol>
)

export type CiRunSettingSwitchProps = {
  isChecked: boolean
  isDisabled?: boolean
  onCheckedChange: (isChecked: boolean) => unknown
  className?: string
}

/** The `create_scans_on_ci_run` switch, with the Azure DevOps setup it needs listed under it once it is on. */
export const CiRunSettingSwitch: React.FC<CiRunSettingSwitchProps> = ({
  isChecked,
  isDisabled,
  onCheckedChange,
  className,
}) => (
  <div className={classNames(styles.setting, className)}>
    <label className={styles.switchRow}>
      <Switch checked={isChecked} disabled={isDisabled} onCheckedChange={onCheckedChange} />
      <span className={styles.switchLabel}>{CI_RUN_SETTING_LABEL}</span>
    </label>
    {isChecked && <CiRunSetupSteps />}
  </div>
)
